import * as React from "react";
import * as ReactDOM from "react-dom";
import Slider, { Settings as SliderSettings } from "react-slick";
import cx from "classnames";

import { LoadingSpinner, CustomScrollbar } from "../../../components";
import "./LayoutCarousel.css";

export interface LayoutCarouselProps {
  children: JSX.Element | JSX.Element[];
  isLoading: boolean;
  initialSlide: number;
  onChange: (index: number) => void;
}

interface LayoutCarouselState {
  height: number;
}

const getContainerClasses = ({ isLoading }: LayoutCarouselProps) =>
  cx("layout-carousel__carousel-container", {
    "layout-carousel__carousel-container--loading": isLoading,
  });

class LayoutCarousel extends React.Component<LayoutCarouselProps> {
  state: LayoutCarouselState;
  private slider: Slider;

  private settings: SliderSettings = {
    autoplay: false,
    arrows: false,
    dots: false,
    initialSlide: this.props.initialSlide,
  };

  constructor(props: LayoutCarouselProps) {
    super(props);

    this.state = {
      height: 0,
    };
  }

  componentDidMount() {
    const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
    const height = window.innerHeight - rect.top - 76 - 68 - 42; // footer height = 76, description = 93, slider-nav = 42
    this.setState({ height });
  }

  private assignRef = (el: Slider) => (this.slider = el);

  private handlePrev = () => {
    if (this.slider) {
      this.slider.slickPrev();
    }
  };

  private handleNext = () => {
    if (this.slider) {
      this.slider.slickNext();
    }
  };

  public render() {
    const props = this.props;

    return (
      <section className={getContainerClasses(props)}>
        {props.isLoading ? (
          <LoadingSpinner large />
        ) : (
          <CustomScrollbar maxHeight={this.state.height}>
            <Slider
              className="layout-carousel__carousel"
              ref={this.assignRef}
              afterChange={props.onChange}
              {...this.settings}
            >
              {props.children}
            </Slider>
          </CustomScrollbar>
        )}
        <div className="layout-carousel__nav">
          <button
            className="layout-carousel__nav-btn"
            onClick={this.handlePrev}
          >
            <i className="fa fa-caret-left" />
          </button>
          <p className="layout-carousel__nav-text">Tôi chọn mẫu này !</p>
          <button
            className="layout-carousel__nav-btn"
            onClick={this.handleNext}
          >
            <i className="fa fa-caret-right" />
          </button>
        </div>
      </section>
    );
  }
}

export default LayoutCarousel;



// WEBPACK FOOTER //
// ./src/routes/WizardLayoutChoice/components/LayoutCarousel.tsx